import React, { useMemo, useState } from 'react';
import classnames from 'classnames';
import { useTranslation } from 'react-i18next';

import emailIcon from '../imgs/icon-email.svg';
import worldIcon from '../imgs/icon-world.svg';
import selectArrowIcon from '../imgs/select-arrow.svg';
import selectedIcon from '../imgs/selected-icon.svg';
import { useLanguageChange } from '../helpers/hooks';

import { useComponentVisible } from '../helpers/hooks';
import { displayedLangOptions } from '../helpers/constants';

export default function Nav() {
  const { t, i18n } = useTranslation();
  const changeLanguage = useLanguageChange();
  const [isLangDropdownVisible, setIsLangDropdownVisible] = useState(false);
  const { ref, isComponentVisible, setIsComponentVisible } =
    useComponentVisible(false);

  const currentLanguageLabel = useMemo(
    () =>
      displayedLangOptions.find((lang) => lang.value === i18n.language)
        ?.label || '',
    [displayedLangOptions, i18n.language]
  );

  const toggleLangSelect = () => {
    setIsLangDropdownVisible((prev) => !prev);
  };

  return (
    <header>
      <div className="header__container">
        <div className="logo" />
        <div className="header__right">
          <div
            className={classnames('support-mob__dropdown hidden_mobile', {
              show: isComponentVisible,
            })}
          >
            <a
              className="mail-link "
              href={`mailto:${process.env.REACT_APP_SUPPORT_EMAIL}`}
            >
              <img src={emailIcon} alt="" />{' '}
              {process.env.REACT_APP_SUPPORT_EMAIL}
            </a>
          </div>
          <div
            className={classnames('langbar-wrapper', {
              active: isLangDropdownVisible,
            })}
          >
            <div
              className={classnames('langbar-toggle', {
                active: isLangDropdownVisible,
              })}
              onClick={toggleLangSelect}
            >
              <img src={worldIcon} alt="" />
              <span>{currentLanguageLabel}</span>
              <img
                src={selectArrowIcon}
                alt=""
                className={classnames('langbar-arrow', {
                  rotated: isLangDropdownVisible,
                })}
              />
            </div>
            {isLangDropdownVisible && (
              <div className="langbar-dropdown">
                {displayedLangOptions.map((lang) => {
                  const onClick = () => {
                    changeLanguage(lang.value);
                    toggleLangSelect();
                  };
                  const isSelected = i18n.language === lang.value;
                  return (
                    <div
                      key={lang.value}
                      className={classnames('langbar-option', {
                        'langbar--active': isSelected,
                      })}
                      onClick={onClick}
                    >
                      {lang.label}
                      {isSelected && <img src={selectedIcon} alt="selected" />}
                    </div>
                  );
                })}
              </div>
            )}
          </div>
        </div>
      </div>
      <div className="header__bottom hidden_desktop">
        <div
          className="support-mob__btn"
          onClick={() => {
            setIsComponentVisible(!isComponentVisible);
          }}
          ref={ref}
        >
          {t('Nav.Support')}
        </div>
        <div
          className={classnames('support-mob__dropdown', {
            show: isComponentVisible,
          })}
        >
          <a
            className="mail-link "
            href={`mailto:${process.env.REACT_APP_SUPPORT_EMAIL}`}
          >
            <img src={emailIcon} alt="" /> {process.env.REACT_APP_SUPPORT_EMAIL}
          </a>
        </div>
      </div>
    </header>
  );
}
